import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Portal from 'react-portal';

import ModalHeader from './Header';
import { Wrapper, Overlay, BodyWrapper, Body, Content } from './ModalUnits';

class Modal extends Component {
  static propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    padding: PropTypes.string,
    width: PropTypes.string,
    contentWidth: PropTypes.string,
    height: PropTypes.string,
    onClose: PropTypes.func,
    onOverlayClick: PropTypes.func,
    noUserSelect: PropTypes.bool,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    className: null,
    active: false,
    title: null,
    padding: '24px',
    width: '100%',
    height: null,
    noUserSelect: false,
    contentWidth: null,
    onClose: null,
    onOverlayClick: null
  };

  beforeClose = (portal, removeFromDOM) => {
    portal.classList.add('portal-close-animation');
    setTimeout(removeFromDOM, 400);
  };

  render() {
    return (
      <Portal isOpened={this.props.active} beforeClose={this.beforeClose}>
        <Wrapper className="modal">
          <Overlay onClick={this.props.onOverlayClick} />
          <BodyWrapper
            modalWidth={this.props.width}
            modalHeight={this.props.height}
          >
            <Body
              modalWidth={this.props.width}
              modalPadding={this.props.padding}
              contentWidth={this.props.contentWidth}
            >
              <Content
                className={this.props.className}
                noUserSelect={this.props.noUserSelect}
              >
                <ModalHeader
                  title={this.props.title}
                  size={this.props.width === '100%' ? 'normal' : 'small'}
                  onClose={this.props.onClose}
                />
                {this.props.children}
              </Content>
            </Body>
          </BodyWrapper>
        </Wrapper>
      </Portal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/units/Modal/Modal.js